// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgOHL","left":"styles_left__SI9Ry","desktopActions":"styles_desktopActions__1GZp-","title":"styles_title__2RoH1"};